module.exports = __webpack_public_path__ + "img/96.80d507ce.png";